class CurriculumService {
    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }

    list() {
        return this.$http({
            method: 'GET',
            url: '/api/curriculum',
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            cache: true,
            data: {},
        })
            .then((res => res.data))
            .catch(error => this.$q.reject(error));
    }

    listNoLegacy() {
        return this.$http({
            method: 'GET',
            url: '/api/curriculum/list',
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            cache: true,
            data: {},
        })
            .then((res => res.data))
            .catch(error => this.$q.reject(error));
    }

    getById(id) {
        return this.$http({
            method: 'GET',
            url: `/api/curriculum/${id}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            cache: true,
            data: {},
        })
            .then((res => res.data))
            .catch(error => this.$q.reject(error));
    }

    save(curriculum) {
        return this.$http.post(`/api/curriculum/${curriculum.id}`, curriculum, {
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
        })
            .then((res => res.data))
            .catch(error => this.$q.reject(error));
    }

    create(curriculum) {
        return this.$http.post('/api/curriculum', curriculum, {
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
        })
            .then((res => res.data))
            .catch(error => this.$q.reject(error));
    }

    delete(id) {
        return this.$http({
            method: 'DELETE',
            url: `/api/curriculum/${id}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        })
            .then((res => res.data))
            .catch(error => this.$q.reject(error));
    }
}

export default CurriculumService;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/services/curriculumService.js